import { ReactComponent as AddNewField } from 'assets/icons/Group 239993.svg';
import { ReactComponent as InfoIcon } from 'assets/icons/Layer_2.svg';
import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import DiscountAccordion from './DiscountAccordion';
import { fontConfig } from "theme/fontConfig";

const PriceDiscount = ({ formik }) => {
  const [expandedIndex, setExpandedIndex] = useState(0);

  return (
    <div>
      {formik.values?.discount?.length > 0 && (
        <div
          style={{
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px',
            background: '#d3ddfc',
            borderRadius: '4px',
            fontFamily: fontConfig.EventsPriceDiscountTextFont.family,
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '18px',
            color: '#2555ef',
          }}
        >
          <InfoIcon style={{ marginRight: '12px', minWidth: '18px' }} />
          All discounts will be applied only to the ticket fee.
        </div>
      )}
      <div className="class_discount_content">
        {formik.values?.discount?.map((_, index) => {
          const isExpanded = index === expandedIndex;

          return (
            <DiscountAccordion
              key={index}
              summary={
                <div className={isExpanded ? 'text-primary' : ''}>
                  Discount {index + 1 < 10 ? `0${index + 1}` : index + 1}
                </div>
              }
              formik={formik}
              index={index}
              handleDeleteClick={() => {
                const discount = formik.values?.discount;
                discount.splice(index, 1);
                formik.setFieldValue('discount', discount);

                // If the deleted item was the currently expanded one,
                // reset the expanded index to -1
                if (index === expandedIndex) {
                  setExpandedIndex(-1);
                }
              }}
              isExpanded={isExpanded}
              handleExpand={() => {
                setExpandedIndex(isExpanded ? -1 : index);
              }}
            />
          );
        })}
      </div>
      <div
        className="add_new_discount d-flex align-items-center justify-content-center w-100"
        style={{
          height: '40px',
          color: '#002E5C',
          cursor: 'pointer',
          fontSize: '14px',
          marginTop: '24px',
          border: '1px dashed rgba(0, 46, 92, 0.2)',
          borderRadius: '4px',
        }}
        onClick={async () => {
          const errors = await formik.validateForm();
          const hasDiscountErrors =
            Array.isArray(errors?.discount) &&
            errors.discount.some((e) => e && Object.keys(e).length > 0);

          if (hasDiscountErrors) {
            const newTouched = { ...formik.touched };
            newTouched.discount = (formik.values?.discount || []).map((_, i) => ({
              ...(formik.touched?.discount?.[i] || {}),
              discount_name: true, discount_type: true, price_type: true,
              value: true, amount: true, quantity: true,
              start_date: true, end_date: true,
            }));
            formik.setTouched(newTouched);

            const missing = [];
            errors.discount.forEach((discErr, i) => {
              if (!discErr) return;
              const discLabel = formik.values?.discount?.[i]?.discount_name || `Discount ${i + 1}`;
              if (discErr.discount_name) missing.push(`${discLabel} - Name`);
              if (discErr.discount_type) missing.push(`${discLabel} - Type`);
              if (discErr.price_type) missing.push(`${discLabel} - Price Type`);
              if (discErr.value) missing.push(`${discLabel} - Value`);
              if (discErr.amount) missing.push(`${discLabel} - Amount`);
              if (discErr.quantity) missing.push(`${discLabel} - Quantity`);
              if (discErr.start_date) missing.push(`${discLabel} - Start Date`);
              if (discErr.end_date) missing.push(`${discLabel} - End Date`);
            });

            toastr.info(
              'Validation',
              missing.length > 0
                ? `Please fill the following required fields: ${missing.join(', ')}`
                : 'Please fill all the mandatory fields before adding a new discount'
            );
            return;
          }

          const newIndex = formik.values?.discount?.length || 0;
          formik.setFieldValue('discount', [
            ...formik.values?.discount,
            {
              discount_name: '',
              price_type: 'fixed',
              value: '',
              discount_type: 'Date',
              start_date: '',
              end_date: '',
            },
          ]);
          setExpandedIndex(newIndex);
        }}
      >
        <AddNewField className="mr-2" /> Add discount{' '}
        {formik.values?.discount?.length + 1 < 10
          ? `0${formik.values?.discount?.length + 1}`
          : formik.values?.discount?.length + 1}
      </div>
    </div>
  );
};

export default PriceDiscount;
